module.exports = __webpack_public_path__ + "img/user.4e956c26.png";